(function () {
  "use strict";

  var roots = document.querySelectorAll("[data-psychic-compass]");
  if (!roots.length) return;

  var PSYCHIC_PRODUCT_REGISTRY = { indepth: "53705415098641" };
  var PSYCHIC_PRODUCT_SKU = "READING-PREMIUM";
  var PSYCHIC_PREVIEW_VERSION = "psychic-card-pattern-v1";

  Array.prototype.forEach.call(roots, function (root) {
    var apiBase = String(root.getAttribute("data-api-base") || "").replace(/\/$/, "");
    if (!apiBase) return;
    function normalizeLocale(value) {
      var raw = String(value || "en").trim().replace(/_/g, "-").toLowerCase();
      var registry = window.DeckauraLocaleRegistry && window.DeckauraLocaleRegistry.locales;
      if (registry) {
        var canonical = Object.keys(registry).filter(function (key) {
          return (registry[key].aliases || []).indexOf(raw) >= 0;
        })[0];
        if (canonical) return canonical;
      }
      if (raw === "pt-pt") return "pt-PT";
      if (raw === "pt" || raw.indexOf("pt-br") === 0) return "pt-BR";
      if (raw.indexOf("de") === 0) return "de";
      if (raw.indexOf("es") === 0) return "es";
      if (raw.indexOf("tr") === 0) return "tr";
      return "en";
    }
    var locale = normalizeLocale(root.getAttribute("data-pc-locale") || document.documentElement.lang || "en");
    var storageKey = "deckaura_psychic_compass_v1_" + locale;
    var visitorKey = "deckaura_psychic_visitor_v1";
    var analyticsSessionKey = "deckaura_psychic_analytics_session_v1_" + locale;
    var translations = {
      en: {
        assurance: "Reading assurances", trust1: "1 free reading / 24h", trust2: "No signup", trust3: "No credit card", trust4: "Private", trust5: "18+",
        stepQuestion: "1 Your question", questionLabel: "What would you like clarity on today?", questionPlaceholder: "Type the question that is already on your mind…", questionHelp: "One honest question is enough. You will not need to type it again.", topicAria: "Optional question topic", love: "Love & Relationships", career: "Career & Money", decision: "A Decision", timing: "Timing & What's Next", life_path: "Life Path & Purpose", signs: "Dreams, Signs & Numbers", start: "Start My Free Reading →", disclosure: "A symbolic reading shaped around your question with Deckaura’s tarot, rune, astrology and numerology methods. For reflection, not live human advice or a guaranteed prediction.",
        stepContext: "2 One useful detail", shortDetail: "Add one short detail", birth: "Birth date (optional — adds a Life Path layer)", chooseCards: "Choose My Cards →", editQuestion: "← Edit my question",
        stepCards: "3 The Intuitive Compass", cardsTitle: "Choose the two cards that pull you in", cardsHelp: "First: The Energy Now. Second: What Shifts It.", cardsAria: "Choose exactly two cards", card: "Card", firstCard: "Choose your first card.", reveal: "Reveal My Free Reading →", changeDetail: "← Change the detail",
        loadingTitle: "Connecting your question and symbols", loadingHelp: "No email is needed. Keep this tab open for your free signal.", loading1: "Reading the energy now…", loading2: "Connecting what shifts it…", loading3: "Adding your supporting signal…", loading4: "Checking the reading for consistency…",
        used: "Your reading used", direct: "Your Direct Signal", why: "Why It Leans This Way", hidden: "The Hidden Influence", control: "What Is Within Your Control", uncertain: "What Remains Uncertain",
        followupStep: "✓ One free follow-up", followupLabel: "What would you like to understand more clearly?", followupButton: "Ask My Follow-Up", followupKicker: "Your Follow-Up",
        offerKicker: "Continue with the exact same question and symbols", offerDefault: "Go deeper into the deciding condition.", complete: "Complete personalized reading", packageFallback: "In-Depth", packageDetail: "1,250–1,500 words · your exact question · two possible paths · a practical 30-day plan", checkingPrice: "Price is being checked…", checkoutFallback: "Get My In-Depth Reading", delivery1: "Created with AI and automated quality checks. Delivered by email with a private reading page.", delivery2: "Your exact question and cards stay together through checkout", delivery3: "100% digital · nothing ships",
        privacySummary: "How is my question handled?", privacyBody: "Your question is securely sent to Deckaura's reading service to create the result. The free session is stored for up to 30 days so you can continue to checkout without retyping your question. It is not added to a marketing list. Optional birth data is used only for the symbolic layer you request.", deleteReading: "Delete this reading",
        minQuestion: "Write one clear question using at least 8 characters.", understanding: "Understanding your question…", restrictedContext: "No additional context collected for a restricted question.", understood: "Question understood. One useful detail is next.", contextFallback: "Add one useful detail.", contextRequired: "Add one short detail, or add your optional birth date.", optionRequired: "Choose the option that best matches your situation.", chooseTwo: "Choose two cards for The Intuitive Compass.", energyNow: "Energy Now", shiftsIt: "What Shifts It", secondCard: "Now choose What Shifts It.", cardsReady: "Your two cards are ready.", exactlyTwo: "Choose exactly two cards.", resultReady: "Your free signal is ready.", supporting: "Supporting signal", followupRequired: "Write one short follow-up question.", followupBusy: "Connecting this to your reading…", followupReady: "Your free follow-up is ready.", verifyPackage: "Verifying your package…", openCheckout: "Opening secure checkout…", restored: "Your saved symbols and result have been restored. Your original question stays attached to the reading service.", deleteConfirm: "Delete this reading and its saved question? This cannot be undone.", deleting: "Deleting…",
        errLimit: "Your free reading renews every 24 hours. Return to this page when your next reading is available.", errProduct: "This package is temporarily paused while we verify its Shopify price. No item was added to your cart.", errPaid: "A paid prediction is not offered for high-stakes questions. Please use the grounded next step in your free answer.", errProgress: "Your reading is still being prepared. Wait a moment, then try once more.", errDefault: "We could not complete that step. Please try again.", upright: "upright", reversed: "reversed"
      },
      de: {
        assurance: "Hinweise zur Deutung", trust1: "1 kostenlose Deutung pro 24 Std.", trust2: "Ohne Anmeldung", trust3: "Keine Kreditkarte", trust4: "Privat", trust5: "Ab 18",
        stepQuestion: "1 Deine Frage", questionLabel: "Wozu wünschst du dir heute Klarheit?", questionPlaceholder: "Schreibe die Frage auf, die dich bereits beschäftigt…", questionHelp: "Eine ehrliche Frage genügt. Du musst sie später nicht erneut eingeben.", topicAria: "Optionales Thema der Frage", love: "Liebe & Beziehungen", career: "Beruf & Finanzen", decision: "Eine Entscheidung", timing: "Zeitpunkt & nächste Schritte", life_path: "Lebensweg & Bestimmung", signs: "Träume, Zeichen & Zahlen", start: "Kostenlose Deutung starten →", disclosure: "Eine symbolische Deutung, abgestimmt auf deine Frage und Deckauras Tarot-, Runen-, Astrologie- und Numerologiemethoden. Zur Reflexion, nicht als menschliche Live-Beratung oder garantierte Vorhersage.",
        stepContext: "2 Ein hilfreiches Detail", shortDetail: "Ein kurzes Detail ergänzen", birth: "Geburtsdatum (optional — ergänzt eine Lebensweg-Ebene)", chooseCards: "Meine Karten wählen →", editQuestion: "← Frage bearbeiten",
        stepCards: "3 Der Intuitive Kompass", cardsTitle: "Wähle die zwei Karten, die dich anziehen", cardsHelp: "Zuerst: Die aktuelle Energie. Danach: Was sie verändert.", cardsAria: "Genau zwei Karten wählen", card: "Karte", firstCard: "Wähle deine erste Karte.", reveal: "Kostenlose Deutung anzeigen →", changeDetail: "← Detail ändern",
        loadingTitle: "Deine Frage wird mit den Symbolen verbunden", loadingHelp: "Keine E-Mail erforderlich. Lass diesen Tab für dein kostenloses Signal geöffnet.", loading1: "Die aktuelle Energie wird gedeutet…", loading2: "Die Veränderung wird eingeordnet…", loading3: "Das ergänzende Symbol wird hinzugefügt…", loading4: "Die Deutung wird auf Stimmigkeit geprüft…",
        used: "Für deine Deutung verwendet", direct: "Dein direktes Signal", why: "Warum es in diese Richtung weist", hidden: "Der verborgene Einfluss", control: "Was du beeinflussen kannst", uncertain: "Was offenbleibt",
        followupStep: "✓ Eine kostenlose Rückfrage", followupLabel: "Was möchtest du noch genauer verstehen?", followupButton: "Rückfrage stellen", followupKicker: "Deine Rückfrage",
        offerKicker: "Mit derselben Frage und denselben Symbolen fortfahren", offerDefault: "Vertiefe den entscheidenden Zusammenhang.", complete: "Vollständige persönliche Deutung", packageFallback: "Ausführlich", packageDetail: "1.250–1.500 Wörter · deine genaue Frage · zwei mögliche Wege · ein praktischer 30-Tage-Plan", checkingPrice: "Preis wird geprüft…", checkoutFallback: "Ausführliche Deutung erhalten", delivery1: "Mit KI erstellt und automatisch auf Qualität geprüft. Zustellung per E-Mail mit einer privaten Deutungsseite.", delivery2: "Deine genaue Frage und Karten bleiben im Checkout zusammen", delivery3: "100 % digital · kein Versand",
        privacySummary: "Wie wird meine Frage verarbeitet?", privacyBody: "Deine Frage wird sicher an Deckauras Deutungsdienst übermittelt, um das Ergebnis zu erstellen. Die kostenlose Sitzung wird bis zu 30 Tage gespeichert, damit du ohne erneute Eingabe zum Checkout weitergehen kannst. Sie wird keiner Marketingliste hinzugefügt. Ein optionales Geburtsdatum wird nur für die gewünschte symbolische Ebene verwendet.", deleteReading: "Diese Deutung löschen",
        minQuestion: "Formuliere eine klare Frage mit mindestens 8 Zeichen.", understanding: "Deine Frage wird eingeordnet…", restrictedContext: "Bei einer sensiblen Frage werden keine zusätzlichen Angaben erfasst.", understood: "Frage verstanden. Als Nächstes hilft ein Detail.", contextFallback: "Ergänze ein hilfreiches Detail.", contextRequired: "Ergänze ein kurzes Detail oder optional dein Geburtsdatum.", optionRequired: "Wähle die Option, die am besten zu deiner Situation passt.", chooseTwo: "Wähle zwei Karten für den Intuitiven Kompass.", energyNow: "Aktuelle Energie", shiftsIt: "Was sie verändert", secondCard: "Wähle jetzt, was sie verändert.", cardsReady: "Deine zwei Karten sind bereit.", exactlyTwo: "Wähle genau zwei Karten.", resultReady: "Dein kostenloses Signal ist bereit.", supporting: "Ergänzendes Symbol", followupRequired: "Formuliere eine kurze Rückfrage.", followupBusy: "Die Rückfrage wird mit deiner Deutung verbunden…", followupReady: "Deine kostenlose Rückfrage ist bereit.", verifyPackage: "Paket und Preis werden geprüft…", openCheckout: "Sicherer Checkout wird geöffnet…", restored: "Deine gespeicherten Symbole und dein Ergebnis wurden wiederhergestellt. Deine ursprüngliche Frage bleibt beim Deutungsdienst hinterlegt.", deleteConfirm: "Diese Deutung und die gespeicherte Frage endgültig löschen?", deleting: "Wird gelöscht…",
        errLimit: "Deine kostenlose Deutung wird alle 24 Stunden erneuert. Kehre zurück, sobald die nächste Deutung verfügbar ist.", errProduct: "Dieses Paket ist vorübergehend pausiert, während wir den Shopify-Preis prüfen. Deinem Warenkorb wurde nichts hinzugefügt.", errPaid: "Für sensible Fragen wird keine kostenpflichtige Vorhersage angeboten. Nutze bitte den bodenständigen nächsten Schritt aus deiner kostenlosen Antwort.", errProgress: "Deine Deutung wird noch erstellt. Warte einen Moment und versuche es erneut.", errDefault: "Dieser Schritt konnte nicht abgeschlossen werden. Versuche es bitte erneut.", upright: "aufrecht", reversed: "umgekehrt"
      },
      es: {
        assurance: "Garantías de la lectura", trust1: "1 lectura gratis cada 24 h", trust2: "Sin registro", trust3: "Sin tarjeta", trust4: "Privada", trust5: "Mayores de 18",
        stepQuestion: "1 Tu pregunta", questionLabel: "¿Sobre qué te gustaría tener claridad hoy?", questionPlaceholder: "Escribe la pregunta que ya tienes en mente…", questionHelp: "Una pregunta sincera es suficiente. No tendrás que escribirla de nuevo.", topicAria: "Tema opcional de la pregunta", love: "Amor y relaciones", career: "Trabajo y dinero", decision: "Una decisión", timing: "Momento y próximos pasos", life_path: "Camino de vida y propósito", signs: "Sueños, señales y números", start: "Empezar mi lectura gratis →", disclosure: "Una lectura simbólica adaptada a tu pregunta con los métodos de tarot, runas, astrología y numerología de Deckaura. Para reflexionar; no sustituye una consulta humana en directo ni garantiza predicciones.",
        stepContext: "2 Un detalle útil", shortDetail: "Añade un detalle breve", birth: "Fecha de nacimiento (opcional — añade una capa de Camino de Vida)", chooseCards: "Elegir mis cartas →", editQuestion: "← Editar mi pregunta",
        stepCards: "3 La Brújula Intuitiva", cardsTitle: "Elige las dos cartas que más te atraigan", cardsHelp: "Primero: La energía actual. Después: Lo que la transforma.", cardsAria: "Elige exactamente dos cartas", card: "Carta", firstCard: "Elige tu primera carta.", reveal: "Ver mi lectura gratis →", changeDetail: "← Cambiar el detalle",
        loadingTitle: "Conectando tu pregunta con los símbolos", loadingHelp: "No necesitas correo electrónico. Mantén esta pestaña abierta para recibir tu señal gratuita.", loading1: "Leyendo la energía actual…", loading2: "Conectando lo que la transforma…", loading3: "Añadiendo la señal complementaria…", loading4: "Comprobando la coherencia de la lectura…",
        used: "Tu lectura utilizó", direct: "Tu señal directa", why: "Por qué apunta en esta dirección", hidden: "La influencia oculta", control: "Lo que está en tus manos", uncertain: "Lo que sigue siendo incierto",
        followupStep: "✓ Una pregunta de seguimiento gratis", followupLabel: "¿Qué te gustaría entender con más claridad?", followupButton: "Hacer mi seguimiento", followupKicker: "Tu seguimiento",
        offerKicker: "Continúa con la misma pregunta y los mismos símbolos", offerDefault: "Profundiza en la condición decisiva.", complete: "Lectura personalizada completa", packageFallback: "En profundidad", packageDetail: "1.250–1.500 palabras · tu pregunta exacta · dos caminos posibles · un plan práctico de 30 días", checkingPrice: "Comprobando el precio…", checkoutFallback: "Obtener mi lectura en profundidad", delivery1: "Creada con IA y controles automáticos de calidad. Entrega por correo con una página privada de lectura.", delivery2: "Tu pregunta exacta y tus cartas siguen juntas durante el pago", delivery3: "100 % digital · sin envío",
        privacySummary: "¿Cómo se trata mi pregunta?", privacyBody: "Tu pregunta se envía de forma segura al servicio de lectura de Deckaura para crear el resultado. La sesión gratuita se conserva hasta 30 días para que puedas pasar al pago sin volver a escribir tu pregunta. No se añade a ninguna lista de marketing. La fecha de nacimiento opcional solo se utiliza para la capa simbólica solicitada.", deleteReading: "Eliminar esta lectura",
        minQuestion: "Escribe una pregunta clara de al menos 8 caracteres.", understanding: "Comprendiendo tu pregunta…", restrictedContext: "No se recopilan más detalles para una pregunta sensible.", understood: "Pregunta comprendida. Ahora añade un detalle útil.", contextFallback: "Añade un detalle útil.", contextRequired: "Añade un detalle breve o, si quieres, tu fecha de nacimiento.", optionRequired: "Elige la opción que mejor refleje tu situación.", chooseTwo: "Elige dos cartas para la Brújula Intuitiva.", energyNow: "Energía actual", shiftsIt: "Lo que la transforma", secondCard: "Ahora elige lo que la transforma.", cardsReady: "Tus dos cartas están listas.", exactlyTwo: "Elige exactamente dos cartas.", resultReady: "Tu señal gratuita está lista.", supporting: "Señal complementaria", followupRequired: "Escribe una pregunta de seguimiento breve.", followupBusy: "Conectando la pregunta con tu lectura…", followupReady: "Tu seguimiento gratuito está listo.", verifyPackage: "Comprobando el paquete y el precio…", openCheckout: "Abriendo el pago seguro…", restored: "Tus símbolos y tu resultado guardados se han restaurado. Tu pregunta original sigue vinculada al servicio de lectura.", deleteConfirm: "¿Eliminar esta lectura y la pregunta guardada? Esta acción no se puede deshacer.", deleting: "Eliminando…",
        errLimit: "Tu lectura gratis se renueva cada 24 horas. Vuelve cuando esté disponible la siguiente lectura.", errProduct: "Este paquete está en pausa mientras verificamos su precio en Shopify. No se ha añadido nada al carrito.", errPaid: "No se ofrece una predicción de pago para preguntas de alto riesgo. Utiliza el siguiente paso sensato de tu respuesta gratuita.", errProgress: "Tu lectura todavía se está preparando. Espera un momento e inténtalo de nuevo.", errDefault: "No pudimos completar este paso. Inténtalo de nuevo.", upright: "derecha", reversed: "invertida"
      }
    };
    var externalTranslations = window.DeckauraPsychicTranslations || {};
    Object.keys(externalTranslations).forEach(function (key) { translations[key] = externalTranslations[key]; });
    var neutralProcessingCopy = {
      en: {
        disclosure: "A symbolic reading shaped around your question with Deckaura’s tarot, rune, astrology and numerology methods. For reflection, not live human advice or a guaranteed prediction.",
        privacyBody: "Your question is securely sent to Deckaura's reading service to create the result. The free session is stored for up to 30 days so you can continue to checkout without retyping your question. It is not added to a marketing list. Optional birth data is used only for the symbolic layer you request."
      },
      de: {
        disclosure: "Eine symbolische Deutung, abgestimmt auf deine Frage und Deckauras Tarot-, Runen-, Astrologie- und Numerologiemethoden. Zur Reflexion, nicht als menschliche Live-Beratung oder garantierte Vorhersage.",
        privacyBody: "Deine Frage wird sicher an Deckauras Deutungsdienst übermittelt, um das Ergebnis zu erstellen. Die kostenlose Sitzung wird bis zu 30 Tage gespeichert, damit du ohne erneute Eingabe zum Checkout weitergehen kannst. Sie wird keiner Marketingliste hinzugefügt. Ein optionales Geburtsdatum wird nur für die gewünschte symbolische Ebene verwendet."
      },
      es: {
        disclosure: "Una lectura simbólica adaptada a tu pregunta con los métodos de tarot, runas, astrología y numerología de Deckaura. Para reflexionar; no sustituye una consulta humana en directo ni garantiza predicciones.",
        privacyBody: "Tu pregunta se envía de forma segura al servicio de lectura de Deckaura para crear el resultado. La sesión gratuita se conserva hasta 30 días para que puedas pasar al pago sin volver a escribir tu pregunta. No se añade a ninguna lista de marketing. La fecha de nacimiento opcional solo se utiliza para la capa simbólica solicitada."
      },
      "pt-BR": {
        disclosure: "Uma leitura simbólica adaptada à sua pergunta com os métodos de tarot, runas, astrologia e numerologia da Deckaura. Serve para reflexão; não é aconselhamento humano ao vivo nem uma previsão garantida.",
        privacyBody: "Sua pergunta é enviada com segurança ao serviço de leitura da Deckaura para criar o resultado. A sessão grátis é armazenada por até 30 dias para que você siga para o checkout sem digitar a pergunta de novo. Ela não é adicionada a uma lista de marketing. A data de nascimento opcional é usada apenas na camada simbólica solicitada."
      },
      "pt-PT": {
        disclosure: "Uma leitura simbólica adaptada à sua pergunta com os métodos de tarot, runas, astrologia e numerologia da Deckaura. Serve para reflexão; não é aconselhamento humano em direto nem uma previsão garantida.",
        privacyBody: "A sua pergunta é enviada em segurança ao serviço de leitura da Deckaura para criar o resultado. A sessão gratuita é guardada até 30 dias para que possa avançar para o checkout sem voltar a escrever a pergunta. Não é adicionada a uma lista de marketing. A data de nascimento opcional é usada apenas na camada simbólica solicitada."
      },
      tr: {
        disclosure: "Sorunuza göre şekillenen; Deckaura’nın tarot, run, astroloji ve numeroloji yöntemlerini kullanan sembolik bir yorumdur. Düşünmeye yardımcı olur; canlı insan danışmanlığı veya kesin gelecek tahmini değildir.",
        privacyBody: "Sorunuz, sonucu oluşturmak için Deckaura'nın yorum hizmetine güvenli biçimde gönderilir. Ücretsiz oturum, sorunuzu yeniden yazmadan ödemeye geçebilmeniz için en fazla 30 gün saklanır. Pazarlama listesine eklenmez. İsteğe bağlı doğum tarihi yalnızca talep ettiğiniz sembolik katmanda kullanılır."
      }
    };
    Object.keys(neutralProcessingCopy).forEach(function (key) {
      translations[key] = Object.assign({}, translations[key] || {}, neutralProcessingCopy[key]);
    });
    var premiumCopy = {
  "en": {
    "premiumBadge": "In-Depth",
    "premiumFeatures": [
      "Your question interpreted through both cards and the supporting signal",
      "Two paths, their risks and the conditions that change the reading",
      "A practical 30-day plan"
    ],
    "premiumFeaturesAria": "Included in your In-Depth reading",
    "packageDetail": "1,250–1,500 words · your exact question · two possible paths · a practical 30-day plan",
    "delivery1": "Created with AI and automated quality checks. Delivered by email with a private reading page.",
    "checkoutNote": "One-time purchase · Secure checkout · Your saved result stays attached",
    "purchaseAria": "Purchase assurances",
    "purchaseTrust": [
      "One-time purchase",
      "Secure Shopify checkout",
      "Most within 90 min · rare quality checks up to 24 h"
    ],
    "deliverySummary": "Delivery details",
    "deliveryBody": "Your exact question, selected cards and saved result stay together. Your digital reading is created with AI and automated quality checks, then sent by email with a link to your private reading page, usually within 90 minutes. Rare quality checks can take up to 24 hours. Nothing ships.",
    "verifyPriceCta": "Check current price and availability",
    "restored": "Your saved symbols and result have been restored. Your original question stays attached to the reading service.",
    "errSession": "This saved reading is no longer available. Start a new free reading to continue.",
    "errDefault": "We could not complete that step. Please try again."
  },
  "de": {
    "premiumBadge": "Ausführlich",
    "premiumFeatures": [
      "Deine Frage anhand beider Karten und des ergänzenden Symbols",
      "Zwei Wege, ihre Risiken und die Bedingungen, die die Deutung verändern",
      "Ein praktischer 30-Tage-Plan"
    ],
    "premiumFeaturesAria": "In deiner ausführlichen Deutung enthalten",
    "packageDetail": "1.250–1.500 Wörter · deine genaue Frage · zwei mögliche Wege · ein praktischer 30-Tage-Plan",
    "delivery1": "Mit KI erstellt und automatisch auf Qualität geprüft. Zustellung per E-Mail mit einer privaten Deutungsseite.",
    "checkoutNote": "Einmaliger Kauf · Sicherer Checkout · Gespeichertes Ergebnis bleibt verbunden",
    "purchaseAria": "Kaufsicherheit",
    "purchaseTrust": [
      "Einmaliger Kauf",
      "Sicherer Shopify-Checkout",
      "Meist innerhalb von 90 Min. · seltene Qualitätsprüfung bis zu 24 Std."
    ],
    "deliverySummary": "Lieferdetails",
    "deliveryBody": "Deine genaue Frage, gewählten Karten und dein gespeichertes Ergebnis bleiben verbunden. Deine digitale Deutung wird mit KI erstellt und automatisch auf Qualität geprüft. Du erhältst sie meist innerhalb von 90 Minuten per E-Mail mit einem Link zu deiner privaten Deutungsseite. Seltene Qualitätsprüfungen können bis zu 24 Stunden dauern. Kein Versand.",
    "verifyPriceCta": "Aktuellen Preis und Verfügbarkeit prüfen",
    "restored": "Deine gespeicherten Symbole und dein Ergebnis wurden wiederhergestellt. Deine ursprüngliche Frage bleibt beim Deutungsdienst hinterlegt.",
    "errSession": "Diese gespeicherte Deutung ist nicht mehr verfügbar. Starte eine neue kostenlose Deutung, um fortzufahren.",
    "errDefault": "Dieser Schritt konnte nicht abgeschlossen werden. Versuche es bitte erneut."
  },
  "es": {
    "premiumBadge": "En profundidad",
    "premiumFeatures": [
      "Tu pregunta interpretada con las dos cartas y la señal de apoyo",
      "Dos caminos, sus riesgos y las condiciones que cambian la lectura",
      "Un plan práctico de 30 días"
    ],
    "premiumFeaturesAria": "Incluido en tu lectura en profundidad",
    "packageDetail": "1.250–1.500 palabras · tu pregunta exacta · dos caminos posibles · un plan práctico de 30 días",
    "delivery1": "Creada con IA y controles automáticos de calidad. Entrega por correo con una página privada de lectura.",
    "checkoutNote": "Compra única · Pago seguro · Tu resultado guardado sigue vinculado",
    "purchaseAria": "Garantías de compra",
    "purchaseTrust": [
      "Compra única",
      "Pago seguro con Shopify",
      "Normalmente en 90 min · revisión excepcional de hasta 24 h"
    ],
    "deliverySummary": "Detalles de entrega",
    "deliveryBody": "Tu pregunta exacta, las cartas seleccionadas y el resultado guardado siguen juntos. Tu lectura digital se crea con IA y controles automáticos de calidad. La recibes por correo con un enlace a tu página privada de lectura, normalmente en 90 minutos. Los controles de calidad excepcionales pueden tardar hasta 24 horas. No hay envío físico.",
    "verifyPriceCta": "Comprobar precio y disponibilidad",
    "restored": "Tus símbolos y tu resultado guardados se han restaurado. Tu pregunta original sigue vinculada al servicio de lectura.",
    "errSession": "Esta lectura guardada ya no está disponible. Empieza una nueva lectura gratis para continuar.",
    "errDefault": "No pudimos completar este paso. Inténtalo de nuevo."
  },
  "pt-BR": {
    "premiumBadge": "Aprofundada",
    "premiumFeatures": [
      "Sua pergunta interpretada com as duas cartas e o sinal de apoio",
      "Dois caminhos, seus riscos e as condições que mudam a leitura",
      "Um plano prático de 30 dias"
    ],
    "premiumFeaturesAria": "Incluído na sua leitura aprofundada",
    "packageDetail": "1.250–1.500 palavras · sua pergunta exata · dois caminhos possíveis · plano prático de 30 dias",
    "delivery1": "Criada com IA e verificações automáticas de qualidade. Entrega por e-mail com uma página privada de leitura.",
    "checkoutNote": "Compra única · Checkout seguro · Seu resultado salvo permanece vinculado",
    "purchaseAria": "Garantias da compra",
    "purchaseTrust": [
      "Compra única",
      "Checkout seguro da Shopify",
      "Geralmente em até 90 min · revisão rara de até 24 h"
    ],
    "deliverySummary": "Detalhes de entrega",
    "deliveryBody": "Sua pergunta exata, as cartas escolhidas e o resultado salvo permanecem juntos. Sua leitura digital é criada com IA e verificações automáticas de qualidade. Ela é enviada por e-mail com um link para sua página privada de leitura, geralmente em até 90 minutos. Verificações de qualidade raras podem levar até 24 horas. Nada é enviado fisicamente.",
    "verifyPriceCta": "Verificar preço e disponibilidade",
    "restored": "Seus símbolos e seu resultado salvos foram restaurados. Sua pergunta original permanece vinculada ao serviço de leitura.",
    "errSession": "Esta leitura salva não está mais disponível. Comece uma nova leitura grátis para continuar.",
    "errDefault": "Não foi possível concluir esta etapa. Tente novamente."
  },
  "pt-PT": {
    "premiumBadge": "Aprofundada",
    "premiumFeatures": [
      "A sua pergunta interpretada com as duas cartas e o sinal de apoio",
      "Dois caminhos, os seus riscos e as condições que alteram a leitura",
      "Um plano prático de 30 dias"
    ],
    "premiumFeaturesAria": "Incluído na sua leitura aprofundada",
    "packageDetail": "1.250–1.500 palavras · a sua pergunta exata · dois caminhos possíveis · plano prático de 30 dias",
    "delivery1": "Criada com IA e verificações automáticas de qualidade. Entrega por e-mail com uma página privada de leitura.",
    "checkoutNote": "Compra única · Checkout seguro · O resultado guardado permanece associado",
    "purchaseAria": "Garantias da compra",
    "purchaseTrust": [
      "Compra única",
      "Checkout seguro da Shopify",
      "Habitualmente em até 90 min · revisão rara até 24 h"
    ],
    "deliverySummary": "Detalhes de entrega",
    "deliveryBody": "A sua pergunta exata, as cartas escolhidas e o resultado guardado permanecem juntos. A sua leitura digital é criada com IA e verificações automáticas de qualidade. É enviada por e-mail com uma ligação para a sua página privada de leitura, habitualmente em até 90 minutos. As verificações de qualidade raras podem demorar até 24 horas. Não existe envio físico.",
    "verifyPriceCta": "Verificar preço e disponibilidade",
    "restored": "Os seus símbolos e o seu resultado guardados foram restaurados. A pergunta original continua associada ao serviço de leitura.",
    "errSession": "Esta leitura guardada já não está disponível. Inicie uma nova leitura gratuita para continuar.",
    "errDefault": "Não foi possível concluir esta etapa. Tente novamente."
  },
  "tr": {
    "premiumBadge": "Derinlemesine",
    "premiumFeatures": [
      "Sorunuzun iki kartınız ve destekleyici işaretle birlikte yorumu",
      "İki olası yol, bu yolların riskleri ve yorumu değiştiren koşullar",
      "Uygulanabilir 30 günlük plan"
    ],
    "premiumFeaturesAria": "Derinlemesine yorumunuza dahil olanlar",
    "packageDetail": "1.250–1.500 kelime · tam sorunuz · iki olası yol · uygulanabilir 30 günlük plan",
    "delivery1": "Yapay zekâ ve otomatik kalite kontrolleriyle hazırlanır. E-posta ve özel yorum sayfasıyla teslim edilir.",
    "checkoutNote": "Tek seferlik satın alma · Güvenli ödeme · Kayıtlı sonucunuz bağlı kalır",
    "purchaseAria": "Satın alma güvenceleri",
    "purchaseTrust": [
      "Tek seferlik satın alma",
      "Güvenli Shopify ödemesi",
      "Çoğu 90 dakika içinde · nadir kalite kontrolleri 24 saate kadar"
    ],
    "deliverySummary": "Teslimat ayrıntıları",
    "deliveryBody": "Tam sorunuz, seçtiğiniz kartlar ve kayıtlı sonucunuz birlikte kalır. Dijital yorumunuz yapay zekâ ile hazırlanır ve otomatik kalite kontrollerinden geçer. Ardından özel yorum sayfanızın bağlantısıyla genellikle 90 dakika içinde e-postayla gönderilir. Nadir kalite kontrolleri 24 saate kadar sürebilir. Fiziksel gönderim yoktur.",
    "verifyPriceCta": "Güncel fiyatı ve uygunluğu kontrol et",
    "restored": "Kayıtlı sembolleriniz ve sonucunuz geri yüklendi. Asıl sorunuz yorum hizmetine bağlı kalır.",
    "errSession": "Bu kayıtlı yorum artık kullanılamıyor. Devam etmek için yeni bir ücretsiz yorum başlatın.",
    "errDefault": "Bu adım tamamlanamadı. Lütfen yeniden deneyin."
  }
};
    var waitCopy = {
      en: { loadingEta: "It usually takes 20–60 seconds.", loadingSlow: "Still writing your reading. Thanks for waiting, it is almost ready." },
      de: { loadingEta: "Das dauert meist 20–60 Sekunden.", loadingSlow: "Deine Deutung wird noch geschrieben. Danke fürs Warten, sie ist fast fertig." },
      es: { loadingEta: "Suele tardar entre 20 y 60 segundos.", loadingSlow: "Seguimos escribiendo tu lectura. Gracias por esperar, ya casi está." },
      "pt-BR": { loadingEta: "Isso costuma levar de 20 a 60 segundos.", loadingSlow: "Ainda estamos escrevendo sua leitura. Obrigado por esperar, ela está quase pronta." },
      "pt-PT": { loadingEta: "Normalmente demora entre 20 e 60 segundos.", loadingSlow: "Ainda estamos a escrever a sua leitura. Obrigado por aguardar, está quase pronta." },
      tr: { loadingEta: "Bu genellikle 20–60 saniye sürer.", loadingSlow: "Yorumunuz hâlâ yazılıyor. Beklediğiniz için teşekkürler, neredeyse hazır." },
    };
    Object.keys(premiumCopy).forEach(function (key) {
      translations[key] = Object.assign({}, translations[key] || {}, premiumCopy[key], waitCopy[key] || waitCopy.en);
    });
    var copy = translations[locale] || translations.en;
    var patternCopy = {
      en: { title: "Your card pattern", fallback: "{first} and {second} form the two-card pattern in your reading. Their contrast reflects the situation and its changing influence; {support} adds the supporting symbolic layer. This brief pattern describes the symbols together and leaves your personal decision open." },
      tr: { title: "Kartlarınızın örüntüsü", fallback: "{first} ve {second}, yorumunuzdaki iki kartlık örüntüyü oluşturuyor. Aralarındaki karşıtlık, mevcut durumu ve değişen etkiyi betimliyor; {support} ise destekleyici sembolik katmanı ekliyor. Bu kısa görünüm, yalnızca bu sembollerin birlikte taşıdığı temaya odaklanıyor ve kişisel kararınızın sonucunu açık bırakıyor." },
      de: { title: "Dein Kartenmuster", fallback: "{first} und {second} bilden das Muster deiner beiden Karten. Ihr Gegensatz beschreibt die Situation und ihren wechselnden Einfluss; {support} ergänzt die unterstützende Symbolebene. Dieser kurze Einblick betrachtet die Symbole gemeinsam und lässt deine persönliche Entscheidung weiterhin offen." },
      es: { title: "El patrón de tus cartas", fallback: "{first} y {second} forman el patrón de tus dos cartas. Su contraste describe la situación y su influencia cambiante; {support} añade la capa simbólica de apoyo. Esta breve vista reúne los símbolos y deja abierta tu decisión personal." },
      "pt-BR": { title: "O padrão das suas cartas", fallback: "{first} e {second} formam o padrão das suas duas cartas. O contraste descreve a situação e sua influência em mudança; {support} acrescenta a camada simbólica de apoio. Esta breve visão reúne os símbolos e mantém sua decisão pessoal em aberto." },
      "pt-PT": { title: "O padrão das suas cartas", fallback: "{first} e {second} formam o padrão das suas duas cartas. O contraste descreve a situação e a sua influência em mudança; {support} acrescenta a camada simbólica de apoio. Esta breve visão reúne os símbolos e mantém a sua decisão pessoal em aberto." }
    };
    var patternLabels = patternCopy[locale] || patternCopy.en;
    var state = {
      visitorId: visitorId(),
      analyticsSessionId: analyticsSessionId(),
      topicHint: "",
      sessionId: "",
      sessionToken: "",
      question: "",
      questionSession: "",
      topic: "general",
      context: "",
      birthDate: "",
      selectedSlots: [],
      offer: null,
      packages: [],
      marketStatus: "idle",
      marketPromise: null,
      result: null,
      preview: null,
      previewVersion: "",
      symbols: null,
      followupAvailable: false,
      followup: null,
      restricted: false,
      createdAt: 0,
      tracked: {},
      checkoutInFlight: false,
      checkoutOwner: null,
      checkoutSerial: 0,
    };
    var loadingTimer = null;
    var readingObserver = null;
    var REQUEST_TIMEOUT_MS = 20000;
    var API_TIMEOUTS = {
      "/api/reading/generate": 160000,
      "/api/reading/followup": 80000,
    };

    var stages = {};
    Array.prototype.forEach.call(root.querySelectorAll("[data-pc-stage]"), function (node) {
      stages[node.getAttribute("data-pc-stage")] = node;
    });

    function one(selector) { return root.querySelector(selector); }
    function all(selector) { return root.querySelectorAll(selector); }
    function setText(selector, value) {
      var node = one(selector);
      if (node) node.textContent = value;
    }
    function setStep(node, value) {
      if (!node) return;
      var badge = node.querySelector("span");
      if (!badge) { node.textContent = value; return; }
      var prefix = String(badge.textContent || "").trim();
      var label = String(value).replace(prefix, "").trim();
      while (badge.nextSibling) node.removeChild(badge.nextSibling);
      node.appendChild(document.createTextNode(" " + label));
    }
    function applyStaticCopy() {
      var trust = all(".pc__trust li");
      var topics = all("[data-topic]");
      var steps = all(".pc__step");
      var sections = all("[data-pc-reading] section");
      var premiumFeatures = all("[data-pc-premium-feature]");
      var purchaseTrust = all("[data-pc-trust]");
      one(".pc__trust").setAttribute("aria-label", copy.assurance);
      [copy.trust1, copy.trust2, copy.trust3, copy.trust4, copy.trust5].forEach(function (value, index) { if (trust[index]) trust[index].textContent = value; });
      setStep(steps[0], copy.stepQuestion);
      setText('[data-pc-stage="question"] .pc__label', copy.questionLabel);
      one("[data-pc-question]").placeholder = copy.questionPlaceholder;
      setText("#" + one("[data-pc-question]").getAttribute("aria-describedby").split(" ")[0], copy.questionHelp);
      one(".pc__topics").setAttribute("aria-label", copy.topicAria);
      Array.prototype.forEach.call(topics, function (button) { button.textContent = copy[button.getAttribute("data-topic")]; });
      setText("[data-pc-start]", copy.start);
      setText(".pc__disclosure", copy.disclosure);
      setStep(steps[1], copy.stepContext);
      setText("[data-pc-context-text-wrap] .sr-only", copy.shortDetail);
      setText("[data-pc-birth-wrap] span", copy.birth);
      setText("[data-pc-context-continue]", copy.chooseCards);
      setText("[data-pc-back-question]", copy.editQuestion);
      setStep(steps[2], copy.stepCards);
      setText('[data-pc-stage="cards"] .pc__stage-title', copy.cardsTitle);
      setText('[data-pc-stage="cards"] .pc__help', copy.cardsHelp);
      one("[data-pc-cards]").setAttribute("aria-label", copy.cardsAria);
      Array.prototype.forEach.call(all("[data-card-slot]"), function (card, index) { card.setAttribute("aria-label", copy.card + " " + (index + 1)); });
      setText("[data-pc-selection]", copy.firstCard);
      setText("[data-pc-generate]", copy.reveal);
      setText("[data-pc-back-context]", copy.changeDetail);
      setText('[data-pc-stage="loading"] .pc__stage-title', copy.loadingTitle);
      setText('[data-pc-stage="loading"] .pc__help', copy.loadingHelp + (copy.loadingEta ? " " + copy.loadingEta : ""));
      setText("[data-pc-method] > p", copy.used);
      if (sections[0]) sections[0].querySelector(".pc__kicker").textContent = patternLabels.title;
      [copy.why, copy.hidden, copy.control, copy.uncertain].forEach(function (value, index) { var heading = sections[index + 1] && sections[index + 1].querySelector("h2"); if (heading) heading.textContent = value; });
      setStep(steps[3], copy.followupStep);
      setText("[data-pc-followup] .pc__label", copy.followupLabel);
      setText("[data-pc-followup-send]", copy.followupButton);
      setText("[data-pc-followup-answer] .pc__kicker", copy.followupKicker);
      setText(".pc__offer-kicker", copy.offerKicker);
      setText("[data-pc-offer-title]", copy.offerDefault);
      setText("[data-pc-complete-label]", copy.complete);
      setText("[data-pc-package-name]", copy.packageFallback);
      setText("[data-pc-package-detail]", copy.packageDetail);
      setText("[data-pc-package-price]", copy.checkingPrice);
      setText("[data-pc-checkout-label]", copy.checkoutFallback);
      setText("[data-pc-premium-badge]", copy.premiumBadge);
      copy.premiumFeatures.forEach(function (value, index) { if (premiumFeatures[index]) premiumFeatures[index].textContent = value; });
      var featureList = one(".pc__premium-features");
      if (featureList) featureList.setAttribute("aria-label", copy.premiumFeaturesAria);
      setText("[data-pc-delivery-method]", copy.delivery1);
      setText("[data-pc-checkout-note]", copy.checkoutNote);
      copy.purchaseTrust.forEach(function (value, index) { if (purchaseTrust[index]) purchaseTrust[index].textContent = value; });
      var trustList = one(".pc__offer-trust");
      if (trustList) trustList.setAttribute("aria-label", copy.purchaseAria);
      setText("[data-pc-delivery-summary]", copy.deliverySummary);
      setText("[data-pc-delivery-body]", copy.deliveryBody);
      setText(".pc__privacy summary", copy.privacySummary);
      setText(".pc__privacy details p", copy.privacyBody);
      setText("[data-pc-delete]", copy.deleteReading);
    }
    function localizedPosition(value) {
      if (value === "Energy Now" || value === "The Energy Now") return copy.energyNow;
      if (value === "What Shifts It") return copy.shiftsIt;
      return value;
    }
    function localizedOrientation(value) {
      if (String(value).toLowerCase() === "upright") return copy.upright;
      if (String(value).toLowerCase() === "reversed") return copy.reversed;
      return value;
    }
    function updateOffer() {
      var product = state.packages.filter(function (item) { return item && item.tier === "indepth"; })[0] || state.packages[0];
      var productReady = Boolean(state.marketStatus === "ready" && product && product.variantId === PSYCHIC_PRODUCT_REGISTRY.indepth && Number.isInteger(Number(product.priceCents)) && Number(product.priceCents) > 0 && String(product.priceLabel || "").trim());
      var canVerify = Boolean((state.marketStatus === "idle" || state.marketStatus === "error") && state.sessionId && state.sessionToken && !state.restricted);
      var checkout = one("[data-pc-checkout]");
      setText("[data-pc-package-name]", product && product.name || copy.packageFallback);
      setText("[data-pc-package-price]", productReady ? product.priceLabel : state.marketStatus === "error" ? copy.errProduct : copy.checkingPrice);
      setText("[data-pc-checkout-label]", productReady ? copy.checkoutFallback : canVerify ? copy.verifyPriceCta : copy.checkingPrice);
      setText("[data-pc-button-price]", productReady ? " · " + product.priceLabel : "");
      if (checkout) {
        checkout.disabled = state.checkoutInFlight || Boolean(state.checkoutOwner) || state.restricted || (!productReady && !canVerify);
        checkout.setAttribute("aria-disabled", checkout.disabled ? "true" : "false");
      }
    }
    function hydrateMarketPackage(fallbackName) {
      if (state.marketPromise) return state.marketPromise;
      var sessionId = state.sessionId, sessionToken = state.sessionToken;
      function sessionIsCurrent() { return state.sessionId === sessionId && state.sessionToken === sessionToken; }
      var variantId = PSYCHIC_PRODUCT_REGISTRY.indepth;
      state.marketStatus = "checking";
      updateOffer();
      state.marketPromise = Promise.all([
        fetchWithTimeout(shopRoot() + "variants/" + variantId + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson),
        fetchWithTimeout(shopRoot() + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson),
      ]).then(function (responses) {
        if (!sessionIsCurrent()) throw checkoutError("stale_market_response");
        var variant = responses[0] || {};
        var cart = responses[1] || {};
        var price = Number(variant.price);
        var currency = String(cart.currency || "").toUpperCase();
        if (String(variant.id) !== variantId || variant.available !== true || variant.requires_shipping !== false || !Number.isInteger(price) || price <= 0 || !/^[A-Z]{3}$/.test(currency)) {
          throw new Error("localized_product_contract_mismatch");
        }
        state.packages = [{
          tier: "indepth",
          variantId: variantId,
          name: String(variant.name || fallbackName || copy.packageFallback),
          priceCents: price,
          currency: currency,
          priceLabel: new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(price / 100),
          includesFollowup: true,
          recommended: true,
        }];
        state.marketStatus = "ready";
        updateOffer();
        saveState();
        return state.packages[0];
      }).catch(function (error) {
        if (!sessionIsCurrent()) throw error;
        state.packages = [];
        state.marketStatus = "error";
        updateOffer();
        throw error;
      }).finally(function () {
        if (sessionIsCurrent()) state.marketPromise = null;
      });
      return state.marketPromise;
    }
    function visitorId() {
      try {
        var existing = localStorage.getItem(visitorKey);
        if (existing && /^[a-zA-Z0-9_-]{16,100}$/.test(existing)) return existing;
        var bytes = new Uint8Array(18);
        crypto.getRandomValues(bytes);
        var next = Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, "0"); }).join("");
        localStorage.setItem(visitorKey, next);
        return next;
      } catch (_) {
        return "visitor_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      }
    }
    function analyticsSessionId() {
      try {
        var existing = sessionStorage.getItem(analyticsSessionKey);
        if (existing && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing)) return existing;
        var next = typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (value) {
              return (Number(value) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(value) / 4).toString(16);
            });
        sessionStorage.setItem(analyticsSessionKey, next);
        return next;
      } catch (_) {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (value) {
          return (Number(value) ^ Math.random() * 16 >> Number(value) / 4).toString(16);
        });
      }
    }
    function announce(message) {
      var live = one("[data-pc-live]");
      if (live) live.textContent = message;
    }
    function stageFocusTarget(name, focusSelector) {
      var stage = stages[name];
      var target = focusSelector ? one(focusSelector) : null;
      if (!target && stage) target = stage.querySelector("h2, h3, legend, button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]");
      if (target && !target.matches("a[href], button, input, textarea, select, [tabindex]")) target.setAttribute("tabindex", "-1");
      return target;
    }
    function showStage(name, focusSelector) {
      Object.keys(stages).forEach(function (key) { stages[key].hidden = key !== name; });
      window.requestAnimationFrame(function () {
        var target = stageFocusTarget(name, focusSelector);
        if (target && typeof target.focus === "function") {
          try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
        }
        if (stages[name]) stages[name].scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    function saveState() {
      if (!state.sessionId || !state.sessionToken) return;
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          sessionId: state.sessionId,
          sessionToken: state.sessionToken,
          topic: state.topic,
          context: state.context,
          birthDate: state.birthDate,
          selectedSlots: state.selectedSlots,
          offer: state.offer,
          packages: state.packages,
          result: state.result,
          preview: state.preview,
          previewVersion: state.previewVersion,
          symbols: state.symbols,
          followupAvailable: state.followupAvailable,
          followup: state.followup,
          restricted: state.restricted,
          createdAt: state.createdAt || (state.createdAt = Date.now()),
        }));
      } catch (_) {}
    }
    function clearState() {
      try { localStorage.removeItem(storageKey); } catch (_) {}
    }
    function parseJson(response) {
      return response.json().catch(function (error) {
        if (error && error.name === "AbortError") throw error;
        return {};
      }).then(function (payload) {
        if (!response.ok || payload.ok === false) {
          var errorText = typeof payload.error === "string" ? payload.error : "";
          var error = new Error(errorText || "request_failed");
          error.code = errorText || (typeof payload.code === "string" ? payload.code : "") || "request_failed";
          error.status = response.status;
          error.safety = payload.safety === true || isSafetyCode(payload.code) || isSafetyCode(errorText) ||
            isSafetyCode(payload.error && typeof payload.error === "object" ? payload.error.code : "");
          throw error;
        }
        return payload;
      });
    }
    function fetchWithTimeout(url, options, timeoutMs, consume) {
      var request = Object.assign({}, options || {});
      if (typeof AbortController !== "function") return fetch(url, request).then(function (response) { return consume ? consume(response) : response; });
      var controller = new AbortController();
      var upstream = request.signal;
      var abortFromUpstream = function () { controller.abort(); };
      if (upstream) {
        if (upstream.aborted) controller.abort();
        else upstream.addEventListener("abort", abortFromUpstream, { once: true });
      }
      request.signal = controller.signal;
      var timer = setTimeout(function () { controller.abort(); }, timeoutMs || REQUEST_TIMEOUT_MS);
      return fetch(url, request).then(function (response) {
        // Keep the deadline active while API JSON is being received, too.
        return consume ? consume(response) : response;
      }).catch(function (error) {
        if (error && error.name === "AbortError") {
          var timeoutError = new Error("request_timeout");
          timeoutError.code = "request_timeout";
          throw timeoutError;
        }
        throw error;
      }).finally(function () {
        clearTimeout(timer);
        if (upstream) upstream.removeEventListener("abort", abortFromUpstream);
      });
    }
    function api(path, options) {
      var sessionId = state.sessionId, sessionToken = state.sessionToken;
      var request = Object.assign({}, options || {});
      request.headers = Object.assign({ "Content-Type": "application/json" }, request.headers || {});
      request.credentials = "omit";
      return fetchWithTimeout(apiBase + path, request, API_TIMEOUTS[path] || REQUEST_TIMEOUT_MS, parseJson).catch(function (error) {
        if (error && typeof error === "object") error.requestPath = path;
        if (error && typeof error === "object") error.sessionIsCurrent = state.sessionId === sessionId && state.sessionToken === sessionToken;
        throw error;
      });
    }
    function track(name, properties) {
      var payload = properties || {};
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name, tool_name: "/pages/free-psychic-reading", reading_type: state.topic }, payload));
      } catch (_) {}
      try {
        if (typeof window.clarity === "function") window.clarity("event", name);
      } catch (_) {}
      api("/api/events", {
        method: "POST",
        keepalive: true,
        body: JSON.stringify({
          event: name,
          visitorId: state.visitorId,
          sessionId: state.sessionId || state.analyticsSessionId,
          sessionToken: state.sessionToken || undefined,
          properties: payload,
        }),
      }).catch(function () {});
    }
    function trackOnce(name, properties) {
      if (state.tracked[name]) return;
      state.tracked[name] = true;
      track(name, properties);
    }
    function setBusy(button, busy, label) {
      if (!button) return;
      if (button.hasAttribute("data-pc-checkout")) {
        var checkoutLabel = button.querySelector("[data-pc-checkout-label]");
        var checkoutPrice = button.querySelector("[data-pc-button-price]");
        state.checkoutInFlight = Boolean(busy || state.checkoutOwner);
        button.disabled = state.checkoutInFlight;
        button.setAttribute("aria-disabled", button.disabled ? "true" : "false");
        button.setAttribute("aria-busy", state.checkoutInFlight ? "true" : "false");
        if (busy && checkoutLabel) checkoutLabel.textContent = label;
        if (busy && checkoutPrice) checkoutPrice.textContent = "";
        if (!busy) updateOffer();
        return;
      }
      if (!button.getAttribute("data-original-label")) button.setAttribute("data-original-label", button.textContent);
      button.disabled = busy;
      button.setAttribute("aria-busy", busy ? "true" : "false");
      button.textContent = busy ? label : button.getAttribute("data-original-label");
    }
    /* Crisis wording is classified by the shared guard (assets/deckaura-crisis-guard.js, loaded before this file by
       sections/page-free-psychic-reading.liquid): the visitor gets the localized support message, nothing is sent to the
       reading service and checkout stays closed. Without the guard nothing is screened here; the reading service's
       *_SAFETY_BLOCKED refusal (and its `restricted` flag) is the backstop and shows the same support message. */
    function isSafetyCode(code) { return /(?:^|_)safety_blocked$/i.test(String(code || "")); }
    function crisisUrgent(text) {
      var g = window.DeckauraCrisisGuard;
      if (!g || typeof g.classify !== "function" || !String(text || "").trim()) return false;
      try { return g.classify(text).kind === "urgent"; } catch (_) { return false; }
    }
    function supportCopy(kind) {
      var g = window.DeckauraCrisisGuard;
      try {
        var m = g && typeof g.message === "function" ? g.message(kind === "blocked" ? "blocked" : "urgent", locale) : "";
        if (m) return m;
      } catch (_) {}
      return copy.errDefault;
    }
    /* Support copy in an error slot is styled as guidance (psychic-funnel.css [data-pc-support]); any other text there
       keeps the error style. */
    function tagSupportNotes() {
      var notes = [supportCopy("urgent"), supportCopy("blocked")];
      Array.prototype.forEach.call(root.querySelectorAll(".pc__error"), function (node) {
        if (notes.indexOf(node.textContent || "") >= 0) node.setAttribute("data-pc-support", "");
        else node.removeAttribute("data-pc-support");
      });
    }
    if (typeof MutationObserver === "function") {
      var supportObserver = new MutationObserver(tagSupportNotes);
      Array.prototype.forEach.call(root.querySelectorAll(".pc__error"), function (node) {
        supportObserver.observe(node, { childList: true, characterData: true, subtree: true });
      });
    }
    /* Everything the visitor typed that the paid reading would use. */
    function typedCrisis() {
      var fields = ["[data-pc-question]", "[data-pc-context-text]", "[data-pc-followup-input]"];
      for (var i = 0; i < fields.length; i++) {
        var node = one(fields[i]);
        if (node && crisisUrgent(node.value)) return true;
      }
      return crisisUrgent(state.context) || crisisUrgent(state.followup && state.followup.question);
    }
    function friendlyError(error) {
      var code = error && error.code;
      if (error && (error.safety || isSafetyCode(code))) {
        state.restricted = true;
        try { updateOffer(); } catch (_) {}
        return supportCopy("blocked");
      }
      if (code === "free_reading_limit_reached") return copy.errLimit;
      if (code === "product_contract_mismatch") return copy.errProduct;
      if (code === "paid_offer_unavailable") return copy.errPaid;
      if (code === "generation_in_progress") return copy.errProgress;
      return copy.errDefault;
    }

    function startReading() {
      if (state.checkoutOwner || state.checkoutInFlight) { announce(copy.verifyPackage); return; }
      var question = String(one("[data-pc-question]").value || "").trim();
      var errorNode = one("[data-pc-question-error]");
      if (question.length < 8) {
        errorNode.textContent = copy.minQuestion;
        one("[data-pc-question]").focus();
        return;
      }
      if (crisisUrgent(question)) {
        errorNode.textContent = supportCopy("urgent");
        announce(errorNode.textContent);
        one("[data-pc-question]").focus();
        return;
      }
      errorNode.textContent = "";
      var button = one("[data-pc-start]");
      setBusy(button, true, copy.understanding);
      api("/api/reading/start", {
        method: "POST",
        body: JSON.stringify({ question: question, topicHint: state.topicHint || undefined, visitorId: state.visitorId, locale: locale, marketPath: shopRoot() }),
      }).then(function (payload) {
        state.sessionId = payload.sessionId;
        state.sessionToken = payload.sessionToken;
        /* Kept in memory only (never saved): shown on the checkout line. */
        state.question = question;
        state.questionSession = payload.sessionId;
        state.createdAt = Date.now();
        state.topic = payload.topic;
        state.offer = payload.offer;
        var fallbackProduct = Array.isArray(payload.packages) ? payload.packages[0] : null;
        state.packages = [];
        state.marketStatus = "idle";
        state.marketPromise = null;
        state.result = null;
        state.preview = null;
        state.previewVersion = "";
        state.symbols = null;
        state.followupAvailable = false;
        state.followup = null;
        state.restricted = Boolean(payload.restricted);
        updateOffer();
        if (!state.restricted) hydrateMarketPackage(fallbackProduct && fallbackProduct.name).catch(function () {});
        saveState();
        configureContext(payload.context || {});
        if (state.restricted) {
          state.context = copy.restrictedContext;
          state.selectedSlots = [0, 1];
          generateReading();
          return;
        }
        announce(copy.understood);
        showStage("context", "[data-pc-context-label]");
      }).catch(function (error) {
        if (error && error.code === "free_reading_limit_reached" && showLimitWall()) { errorNode.textContent = ""; return; }
        errorNode.textContent = friendlyError(error);
      }).finally(function () { setBusy(button, false); if (state.limitReached) button.hidden = true; });
    }
    // The daily limit can answer before the reading service has classified the question, so the wall screens it too:
    // crisis wording (the shared guard's 'urgent') gets the qualified-support note, never the paid offer. A medical,
    // legal or money detail ("my boyfriend is a doctor", "my lawyer says") is an ordinary question and keeps the offer.
    var LIMIT_FOCUS = { love: "love", career: "career", decision: "decision", timing: "timing", life_path: "growth", signs: "general" };
    function isHighStakes(text) {
      return crisisUrgent(text);
    }
    function renderLimitWall() {
      var support = state.restricted || isHighStakes(one("[data-pc-question]").value);
      var text = one("[data-pc-limit-text]");
      var note = one("[data-pc-limit-support]");
      var cta = one("[data-pc-limit-cta]");
      if (note && support) {
        if (!note.hasAttribute("data-pc-default-note")) note.setAttribute("data-pc-default-note", note.textContent);
        var g = window.DeckauraCrisisGuard;
        note.textContent = g && typeof g.message === "function" ? supportCopy(state.restricted ? "blocked" : "urgent") : note.getAttribute("data-pc-default-note");
      }
      if (text) text.hidden = support;
      if (note) note.hidden = !support;
      if (cta) cta.hidden = support;
      return support;
    }
    function showLimitWall() {
      var wall = one("[data-pc-limit]");
      if (!wall) return false;
      state.limitReached = true;
      var cta = one("[data-pc-limit-cta]");
      if (cta && !cta.hasAttribute("data-pc-handoff")) {
        // The product page reads this source and pre-fills the question saved on click.
        try {
          var target = new URL(cta.getAttribute("href"), window.location.origin);
          target.searchParams.set("source", "psychic-limit");
          target.hash = "drp-intake-title";
          cta.setAttribute("href", target.pathname + target.search + target.hash);
        } catch (_) {}
        cta.setAttribute("data-pc-handoff", "");
      }
      var support = renderLimitWall();
      wall.hidden = false;
      trackOnce("psychic_limit_wall_viewed");
      announce(Array.prototype.filter.call(wall.querySelectorAll("p"), function (node) { return !node.hidden; })
        .map(function (node) { return node.textContent.trim(); }).join(" "));
      return support ? "support" : true;
    }
    function saveLimitHandoff(event) {
      var question = String(one("[data-pc-question]").value || "").trim().slice(0, 500);
      if (renderLimitWall()) { if (event) event.preventDefault(); return; }
      if (question.length < 8) return;
      try {
        sessionStorage.setItem("deckaura:reading-handoff:v1", JSON.stringify({
          source: "psychic-limit", focus: LIMIT_FOCUS[state.topicHint] || "general", tier: "indepth", question: question, createdAt: Date.now(),
        }));
      } catch (_) {}
    }

    function configureContext(config) {
      one("[data-pc-context-label]").textContent = config.label || copy.contextFallback;
      var options = one("[data-pc-context-options]");
      options.replaceChildren();
      state.context = "";
      if (config.options && config.options.length) {
        config.options.forEach(function (label) {
          var button = document.createElement("button");
          button.type = "button";
          button.textContent = label;
          button.addEventListener("click", function () {
            Array.prototype.forEach.call(options.children, function (child) { child.classList.remove("is-active"); child.setAttribute("aria-pressed", "false"); });
            button.classList.add("is-active");
            button.setAttribute("aria-pressed", "true");
            state.context = label;
            one("[data-pc-context-error]").textContent = "";
            if (!config.placeholder && !config.birthDate) continueToCards();
          });
          options.appendChild(button);
        });
      }
      var textWrap = one("[data-pc-context-text-wrap]");
      var textInput = one("[data-pc-context-text]");
      textWrap.hidden = !config.placeholder;
      textInput.placeholder = config.placeholder || "";
      textInput.value = "";
      one("[data-pc-birth-wrap]").hidden = !config.birthDate;
      one("[data-pc-birth]").value = "";
    }

    function continueToCards() {
      var textInput = one("[data-pc-context-text]");
      if (!one("[data-pc-context-text-wrap]").hidden) state.context = String(textInput.value || "").trim();
      if (crisisUrgent(state.context)) {
        state.context = "";
        one("[data-pc-context-error]").textContent = supportCopy("urgent");
        announce(one("[data-pc-context-error]").textContent);
        textInput.focus();
        return;
      }
      state.birthDate = one("[data-pc-birth-wrap]").hidden ? "" : String(one("[data-pc-birth]").value || "");
      if (!one("[data-pc-context-options]").children.length && state.context.length < 2 && !state.birthDate) {
        one("[data-pc-context-error]").textContent = copy.contextRequired;
        textInput.focus();
        return;
      }
      if (one("[data-pc-context-options]").children.length && !state.context) {
        one("[data-pc-context-error]").textContent = copy.optionRequired;
        return;
      }
      one("[data-pc-context-error]").textContent = "";
      saveState();
      announce(copy.chooseTwo);
      showStage("cards", ".pc-card");
    }

    function renderCardSelection() {
      Array.prototype.forEach.call(all("[data-card-slot]"), function (card) {
        var cardSlot = Number(card.getAttribute("data-card-slot"));
        var selectedIndex = state.selectedSlots.indexOf(cardSlot);
        card.setAttribute("aria-pressed", selectedIndex >= 0 ? "true" : "false");
        card.querySelector("[data-card-choice]").textContent = selectedIndex === 0 ? copy.energyNow : selectedIndex === 1 ? copy.shiftsIt : "";
      });
      var selection = one("[data-pc-selection]");
      selection.textContent = state.selectedSlots.length === 0 ? copy.firstCard : state.selectedSlots.length === 1 ? copy.secondCard : copy.cardsReady;
      one("[data-pc-generate]").disabled = state.selectedSlots.length !== 2;
      one("[data-pc-cards-error]").textContent = "";
    }

    function selectCard(button) {
      var slot = Number(button.getAttribute("data-card-slot"));
      var index = state.selectedSlots.indexOf(slot);
      if (index >= 0) state.selectedSlots.splice(index, 1);
      else if (state.selectedSlots.length < 2) state.selectedSlots.push(slot);
      renderCardSelection();
      if (state.selectedSlots.length === 2) trackOnce("psychic_cards_selected", { selected_count: 2 });
      saveState();
    }

    function beginLoading() {
      var copies = [copy.loading1, copy.loading2, copy.loading3, copy.loading4];
      var startedAt = Date.now();
      var node = one("[data-pc-loading-copy]");
      node.textContent = copies[0];
      if (loadingTimer) clearInterval(loadingTimer);
      loadingTimer = setInterval(function () {
        var elapsed = Date.now() - startedAt;
        var next = elapsed >= 26000 && copy.loadingSlow ? copy.loadingSlow : copies[Math.min(copies.length - 1, Math.floor(elapsed / 6500))];
        if (next && node.textContent !== next) node.textContent = next;
      }, 1000);
      showStage("loading");
    }

    function generateReading() {
      if (state.selectedSlots.length !== 2) {
        one("[data-pc-cards-error]").textContent = copy.exactlyTwo;
        return;
      }
      beginLoading();
      api("/api/reading/generate", {
        method: "POST",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId, selectedSlots: state.selectedSlots, context: state.context, birthDate: state.birthDate || undefined }),
      }).then(function (payload) {
        state.result = payload.reading;
        state.preview = payload.preview && typeof payload.preview === "object" ? payload.preview : null;
        state.previewVersion = String(payload.previewVersion || "");
        state.symbols = payload.symbols;
        state.restricted = Boolean(payload.restricted);
        state.followupAvailable = payload.followupAvailable !== false && !state.restricted;
        state.followup = payload.followup && payload.followup.answer ? payload.followup : null;
        saveState();
        renderResult(payload);
        trackOnce("psychic_reading_generated", { topic: state.topic });
        announce(copy.resultReady);
        showStage("result", state.restricted ? "[data-pc-support]" : ".pc__reading");
      }).catch(function (error) {
        if (recoverUnavailableSession(error)) return;
        var wall = error && error.code === "free_reading_limit_reached" && showLimitWall();
        if (wall) { one("[data-pc-start]").hidden = true; showStage("question", wall === "support" ? "[data-pc-limit] .pc__kicker" : "[data-pc-limit-cta]"); return; }
        var message = friendlyError(error);
        announce(message);
        /* A safety refusal sends the visitor back to the question, so the message goes where they will see it. */
        if (state.restricted) {
          one("[data-pc-question-error]").textContent = message;
          one("[data-pc-cards-error]").textContent = "";
          showStage("question");
          return;
        }
        one("[data-pc-cards-error]").textContent = message;
        showStage("cards");
      }).finally(function () { if (loadingTimer) clearInterval(loadingTimer); });
    }

    function patternSymbolNames(symbols) {
      var cards = symbols && Array.isArray(symbols.cards) ? symbols.cards : [];
      var names = cards.slice(0, 2).map(function (card) { return String(card && card.name || "").replace(/\s+/g, " ").trim(); });
      names.push(String(symbols && symbols.support && symbols.support.name || "").replace(/\s+/g, " ").trim());
      return cards.length === 2 && names.every(function (name) { return name.length > 0 && name.length <= 160; }) ? names : null;
    }
    function foldedPattern(value) {
      var text = String(value || "").toLowerCase();
      try { text = text.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i"); } catch (_) {}
      return text.replace(/[^\p{L}\p{N}\s]/gu, " ").replace(/\s+/g, " ").trim();
    }
    function psychicPatternPreview(payload) {
      if (!payload || payload.previewVersion !== PSYCHIC_PREVIEW_VERSION || !payload.preview || typeof payload.preview.cardPattern !== "string") return "";
      var text = payload.preview.cardPattern.replace(/\s+/g, " ").trim();
      var names = patternSymbolNames(payload.symbols), words = text.split(/\s+/).filter(Boolean).length;
      if (!names || text.length > 1000 || /[<>]/.test(text) || words < 35 || words > 60) return "";
      var folded = foldedPattern(text);
      if (names.some(function (name) { return folded.indexOf(foldedPattern(name)) < 0; })) return "";
      if (/\b(?:you should|you must|your next step|the deciding condition|right if|only if|if you|accept the offer|stay in|choose your|choose the|du solltest|du musst|wenn du|siguiente paso|debes|deberias|proximo passo|voce deve|voce deveria|sonraki adim|kontrol et|teklifi kabul et)\b/.test(folded)) return "";
      return text;
    }
    function localSymbolPattern(symbols) {
      var names = patternSymbolNames(symbols);
      if (!names) return "";
      return patternLabels.fallback.replace("{first}", names[0]).replace("{second}", names[1]).replace("{support}", names[2]);
    }
    function renderResult(payload) {
      var restricted = Boolean(state.restricted || payload.restricted);
      // Keep the original reading object for the saved session and paid order.
      // Only current bounded card-pattern prose can enter a normal free result.
      Array.prototype.forEach.call(all("[data-reading]"), function (node) { node.textContent = ""; });
      if (restricted) {
        Object.keys(payload.reading || {}).forEach(function (key) {
          var node = one('[data-reading="' + key + '"]');
          if (node) node.textContent = payload.reading[key];
        });
      } else setText('[data-reading="directSignal"]', psychicPatternPreview(payload) || localSymbolPattern(payload.symbols));
      Array.prototype.forEach.call(all("[data-pc-reading] section"), function (section, index) { section.hidden = !restricted && index > 0; });
      var signals = one("[data-pc-signals]");
      signals.replaceChildren();
      if (payload.symbols && payload.symbols.cards) {
        payload.symbols.cards.forEach(function (card) {
          var row = document.createElement("div");
          row.className = "pc-signal";
          var icon = document.createElement("span"); icon.textContent = "✦";
          var copy = document.createElement("span");
          var name = document.createElement("b"); name.textContent = card.name;
          var detail = document.createElement("small"); detail.textContent = localizedPosition(card.position) + " · " + localizedOrientation(card.orientation);
          copy.append(name, detail); row.append(icon, copy); signals.appendChild(row);
        });
        if (payload.symbols.support && payload.symbols.support.name) {
        var supportRow = document.createElement("div"); supportRow.className = "pc-signal";
        var supportIcon = document.createElement("span"); supportIcon.textContent = "◇";
        var supportCopy = document.createElement("span");
        var supportName = document.createElement("b"); supportName.textContent = payload.symbols.support.name;
        var supportDetail = document.createElement("small"); supportDetail.textContent = copy.supporting;
        supportCopy.append(supportName, supportDetail); supportRow.append(supportIcon, supportCopy); signals.appendChild(supportRow);
        }
      }
      var followup = one("[data-pc-followup]");
      followup.hidden = true;
      Array.prototype.forEach.call(all("[data-pc-restricted-only]"), function (section) {
        section.hidden = !restricted;
        var body = section.querySelector("[data-reading]");
        if (body && !restricted) body.textContent = "";
      });
      var support = one("[data-pc-support]");
      if (support) support.hidden = !restricted;
      var openBlock = one("[data-pc-open]");
      if (openBlock) {
        openBlock.hidden = !restricted || !(payload.reading && payload.reading.remainsUncertain);
        var openNote = one("[data-pc-open-note]");
        if (openNote) openNote.hidden = state.restricted;
        var openKicker = one("[data-pc-open-kicker]");
        if (openKicker) {
          if (!openKicker.hasAttribute("data-default-label")) openKicker.setAttribute("data-default-label", openKicker.textContent);
          openKicker.textContent = state.restricted ? copy.uncertain : openKicker.getAttribute("data-default-label");
        }
      }
      if (restricted && payload.followup && payload.followup.answer) {
        var restoredAnswer = one("[data-pc-followup-answer]");
        restoredAnswer.querySelector("p:last-child").textContent = payload.followup.answer;
        restoredAnswer.hidden = false;
        one("[data-pc-followup-input]").value = payload.followup.question || "";
        one("[data-pc-followup-input]").disabled = true;
        one("[data-pc-followup-send]").hidden = true;
      } else if (payload.followupAvailable === false) {
        followup.hidden = true;
      }
      var offer = one("[data-pc-offer]");
      offer.hidden = restricted;
      if (!restricted && state.offer) {
        one("[data-pc-offer-title]").textContent = state.offer.headline;
        updateOffer();
        observeOffer();
      }
      observeReading();
    }

    function sendFollowup() {
      var input = one("[data-pc-followup-input]");
      var question = String(input.value || "").trim();
      var errorNode = one("[data-pc-followup-error]");
      if (question.length < 5) { errorNode.textContent = copy.followupRequired; input.focus(); return; }
      if (crisisUrgent(question)) { errorNode.textContent = supportCopy("urgent"); announce(errorNode.textContent); input.focus(); return; }
      errorNode.textContent = "";
      var button = one("[data-pc-followup-send]");
      setBusy(button, true, copy.followupBusy);
      trackOnce("psychic_followup_started");
      api("/api/reading/followup", {
        method: "POST",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId, followup: question }),
      }).then(function (payload) {
        var answer = one("[data-pc-followup-answer]");
        answer.querySelector("p:last-child").textContent = payload.answer;
        answer.hidden = false;
        input.disabled = true;
        button.hidden = true;
        state.followupAvailable = false;
        state.followup = { question: question, answer: payload.answer };
        saveState();
        trackOnce("psychic_followup_completed");
        announce(copy.followupReady);
      }).catch(function (error) { errorNode.textContent = friendlyError(error); })
        .finally(function () { setBusy(button, false); });
    }

    function observeOffer() {
      var offer = one("[data-pc-offer]");
      if (!offer || offer.hidden || typeof IntersectionObserver !== "function") return;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_offer_viewed"); observer.disconnect(); }
      }, { threshold: .25 });
      observer.observe(offer);
    }

    function observeReading() {
      if (readingObserver) readingObserver.disconnect();
      var reading = one("[data-pc-reading]");
      if (!reading || typeof IntersectionObserver !== "function") return;
      var halfway = reading.querySelectorAll("section")[1];
      readingObserver = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_result_50_percent_read"); readingObserver.disconnect(); }
      }, { threshold: .4 });
      if (halfway) readingObserver.observe(halfway);
      var shown = Array.prototype.filter.call(reading.querySelectorAll("section"), function (section) { return !section.hidden; });
      var lastSection = shown[shown.length - 1];
      if (lastSection) {
        var complete = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) { trackOnce("psychic_result_completed"); complete.disconnect(); }
        }, { threshold: .65 });
        complete.observe(lastSection);
      }
    }

    function shopRoot() {
      var route = "/";
      try { route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/"; } catch (_) {}
      return route.charAt(route.length - 1) === "/" ? route : route + "/";
    }
    function cartItems(cart) { return Array.isArray(cart && cart.items) ? cart.items : []; }
    function itemVariant(item) { return String(item && (item.variant_id || item.variantId || item.id) || ""); }
    function itemSku(item) { return String(item && item.sku || "").toUpperCase(); }
    /* The signed intent carries only hidden properties, so the checkout line
       showed no question. Add the shopper's own question as a visible line
       property. The worker validates the signed hidden properties only, and
       the reading server skips psychic lines (_reading_kind), so this is
       display-only. */
    var QUESTION_LINE_LABELS = { en: "Your question", tr: "Sorunuz", es: "Tu pregunta", de: "Deine Frage", "pt-BR": "Sua pergunta", "pt-PT": "A sua pergunta" };
    function checkoutLineProperties(signed, owner) {
      var properties = Object.assign({}, signed || {});
      var question = String(state.question || "").trim();
      if (question && owner && state.questionSession === owner.sessionId) {
        properties[QUESTION_LINE_LABELS[locale] || QUESTION_LINE_LABELS[String(locale).slice(0, 2)] || QUESTION_LINE_LABELS.en] = question.slice(0, 500);
      }
      return properties;
    }
    function itemHasProperties(item, expected) {
      var properties = item && item.properties || {};
      return Object.keys(expected).every(function (key) { return String(properties[key] || "") === String(expected[key]); });
    }
    function isDeckauraReadingLine(item) {
      var properties = item && item.properties || {};
      return Object.keys(PSYCHIC_PRODUCT_REGISTRY).some(function (tier) { return PSYCHIC_PRODUCT_REGISTRY[tier] === itemVariant(item); }) ||
        /^READING-(?:DEEP|MEDIUM|PREMIUM)$/.test(itemSku(item)) ||
        /^(?:psychic|human_design)$/.test(String(properties._reading_kind || "")) ||
        Boolean(properties._psychic_session || properties._human_design_session || properties._checkout_intent ||
          properties["_Reading ID"] || properties["_Checkout Intent"] || properties["_Checkout Context"] || properties._free_token);
    }
    function readingLines(cart) { return cartItems(cart).filter(isDeckauraReadingLine); }
    function checkoutError(code) { var error = new Error(code); error.code = code; return error; }
    function errorCode(error, fallback) { return String(error && (error.code || error.message) || fallback || "checkout_failed"); }
    function readCart() {
      return fetchWithTimeout(shopRoot() + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }, 15000).then(parseJson);
    }
    function validCheckoutIntent(intent, owner) {
      var properties = intent && intent.properties;
      return Boolean(intent && String(intent.variantId) === owner.variantId &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(intent.intentId || "")) &&
        /^[0-9a-f]{64}$/i.test(String(intent.signature || "")) && properties && !Array.isArray(properties) &&
        properties._reading_kind === "psychic" && properties._psychic_session === owner.sessionId &&
        properties._checkout_intent === intent.intentId && properties._checkout_signature === intent.signature &&
        properties._package_tier === owner.tier && /^[0-9a-f]{64}$/i.test(String(properties._symbol_fingerprint || "")) &&
        String(properties._customer_locale || "").toLowerCase() === String(locale).toLowerCase() &&
        properties._funnel_version === "psychic-compass-2026-08-v1");
    }
    function ownerIsCurrent(owner) {
      return state.checkoutOwner === owner && !owner.stale && !state.restricted &&
        state.sessionId === owner.sessionId && state.sessionToken === owner.sessionToken;
    }
    function exactOwnerLine(item, owner) {
      return Boolean(item && Number(item.quantity) === 1 && itemVariant(item) === owner.variantId &&
        itemSku(item) === owner.expectedSku && item.requires_shipping === false &&
        Number(item.price) === owner.priceCents && Number(item.final_price) > 0 &&
        Number(item.final_price) <= owner.priceCents && itemHasProperties(item, owner.expectedProperties));
    }
    function cartRecovery() {
      var recovery = window.DeckauraReadingCartRecovery;
      if (!recovery || typeof recovery.execute !== "function" || typeof recovery.show !== "function") {
        throw checkoutError("cart_reconciliation_unavailable");
      }
      return recovery;
    }
    function selectionId() { return state.sessionId + "|indepth"; }
    function releaseCheckout(owner, button) {
      if (owner && state.checkoutOwner && state.checkoutOwner !== owner) return;
      state.checkoutOwner = null;
      state.checkoutInFlight = false;
      setBusy(button || one("[data-pc-checkout]"), false);
      updateOffer();
    }
    function recoverUnavailableSession(error, owner) {
      if (!error || !error.sessionIsCurrent || (owner && state.checkoutOwner !== owner) ||
        ["/api/checkout/intent", "/api/reading/generate", "/api/reading/delete"].indexOf(error.requestPath) < 0 ||
        !((error.status === 404 && error.code === "session_not_found") || (error.status === 401 && error.code === "invalid_session_token"))) return false;
      var questionInput = one("[data-pc-question]");
      var question = String(questionInput.value || state.question || "");
      if (state.checkoutOwner) state.checkoutOwner.stale = true;
      state.sessionId = ""; state.sessionToken = ""; state.question = ""; state.questionSession = "";
      state.context = ""; state.birthDate = ""; state.selectedSlots = []; state.createdAt = 0;
      state.result = null; state.preview = null; state.previewVersion = ""; state.symbols = null; state.offer = null;
      state.followup = null; state.followupAvailable = false; state.restricted = false;
      state.packages = []; state.marketStatus = "idle"; state.marketPromise = null;
      clearState();
      releaseCheckout(null, one("[data-pc-checkout]"));
      var host = one("[data-pc-cart-recovery]");
      if (host) host.hidden = true;
      Array.prototype.forEach.call(all(".pc__error"), function (node) { node.textContent = ""; });
      questionInput.value = question;
      one("[data-pc-question-error]").textContent = copy.errSession;
      var deleteButton = one("[data-pc-delete]");
      deleteButton.disabled = false;
      deleteButton.textContent = copy.deleteReading;
      renderCardSelection();
      announce(copy.errSession);
      showStage("question", "[data-pc-question]");
      return true;
    }
    function recoveryHost() {
      var host = one("[data-pc-cart-recovery]");
      if (!host) {
        host = document.createElement("div");
        host.setAttribute("data-pc-cart-recovery", "");
        host.className = "pc__cart-recovery";
        one("[data-pc-checkout-error]").insertAdjacentElement("afterend", host);
      }
      host.hidden = false;
      return host;
    }
    function openPreparedCheckout(owner, button, line) {
      var checkoutErrorNode = one("[data-pc-checkout-error]");
      if (!window.DeckauraCheckout || typeof window.DeckauraCheckout.open !== "function") throw checkoutError("checkout_guard_unavailable");
      setBusy(button, true, copy.openCheckout);
      var opened = window.DeckauraCheckout.open(shopRoot() + "checkout", {
        checkoutSource: owner ? "psychic_funnel" : "psychic_cart_recovery", trigger: button, errorElement: checkoutErrorNode,
        loadingLabel: copy.openCheckout, errorMessage: copy.errDefault, navigationTimeoutMs: 15000,
        variantId: itemVariant(line), readingType: String(line.properties && line.properties._reading_kind || "personalized"),
        funnelVersion: "psychic-compass-2026-08-v1", funnelFlowId: owner ? owner.sessionId : "",
        onNavigationConfirmed: function () { if (owner) owner.navigationConfirmed = true; },
        onNavigationError: function () {
          if (owner && state.checkoutOwner && state.checkoutOwner !== owner) return;
          releaseCheckout(owner, button);
          checkoutErrorNode.textContent = copy.errDefault;
          announce(copy.errDefault);
          showCartRecovery(button);
        }
      });
      if (!opened) { releaseCheckout(owner, button); showCartRecovery(button); }
      return { ok: Boolean(opened), verified: true, navigationStarted: Boolean(opened) };
    }
    function showCartRecovery(button) {
      if (state.checkoutOwner || state.checkoutInFlight) return Promise.resolve(false);
      var recovery;
      try { recovery = cartRecovery(); } catch (_) { return Promise.resolve(false); }
      var host = recoveryHost();
      return Promise.resolve(recovery.show({
        host: host, root: shopRoot(), locale: locale === "pt-BR" ? "ptbr" : locale === "pt-PT" ? "pt" : locale,
        request: fetchWithTimeout, fetchCart: readCart, isReading: isDeckauraReadingLine,
        selection: function () {
          if (!state.sessionId || !state.sessionToken || state.restricted) return null;
          var product = state.packages[0];
          return { id: selectionId(), label: (product && product.name || copy.packageFallback) + (product && product.priceLabel ? " · " + product.priceLabel : ""), question: state.questionSession === state.sessionId ? state.question : "" };
        },
        onResume: function (line) {
          if (state.checkoutOwner || state.checkoutInFlight) return Promise.reject(checkoutError("cart_operation_busy"));
          host.hidden = true;
          return openPreparedCheckout(null, button, line);
        },
        onReplace: function (authorization) { host.hidden = true; return beginCheckout("indepth", button, authorization); },
        onRetry: function () { host.hidden = true; return beginCheckout("indepth", button); }
      })).catch(function () { return false; });
    }
    function settleOwnerFailure(owner, error, button) {
      if (recoverUnavailableSession(error, owner)) return Promise.resolve({ ok: false, code: errorCode(error), sessionReset: true });
      /* execute owns reconciliation and rolls back only its exact signed addition.
         An unrelated saved reading is preserved until the shopper chooses Replace. */
      releaseCheckout(owner, button);
      var errorNode = one("[data-pc-checkout-error]");
      var needsReview = errorCode(error) === "reading_cart_conflict";
      errorNode.textContent = needsReview ? "" : friendlyError(error);
      if (!needsReview) announce(errorNode.textContent);
      return showCartRecovery(button).then(function () { return { ok: false, code: errorCode(error), reviewRequired: needsReview }; });
    }
    function runCheckoutOwner(owner, button) {
      var product = state.packages.filter(function (item) { return item && item.tier === owner.tier; })[0];
      var productPromise = product ? Promise.resolve(product) : hydrateMarketPackage(copy.packageFallback);
      return productPromise.then(function (verifiedProduct) {
        if (!verifiedProduct || verifiedProduct.variantId !== owner.variantId || state.marketStatus !== "ready" ||
          !Number.isInteger(Number(verifiedProduct.priceCents)) || Number(verifiedProduct.priceCents) <= 0 || !String(verifiedProduct.priceLabel || "").trim() || !/^[A-Z]{3}$/.test(String(verifiedProduct.currency || ""))) {
          throw checkoutError("product_contract_mismatch");
        }
        owner.priceCents = Number(verifiedProduct.priceCents);
        owner.currency = verifiedProduct.currency;
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_checkout_owner");
        return api("/api/checkout/intent", {
          method: "POST", headers: { "X-Session-Token": owner.sessionToken },
          body: JSON.stringify({ sessionId: owner.sessionId, tier: owner.tier }),
        });
      }).then(function (intent) {
        if (!validCheckoutIntent(intent, owner)) throw checkoutError("invalid_checkout_intent");
        owner.intent = intent;
        owner.expectedProperties = Object.assign({}, intent.properties);
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_checkout_owner");
        return cartRecovery().execute({
          root: shopRoot(), request: fetchWithTimeout, fetchCart: readCart, isReading: isDeckauraReadingLine,
          item: { id: Number(intent.variantId), quantity: 1, properties: checkoutLineProperties(intent.properties, owner) },
          selectionId: owner.selectionId, authorization: owner.authorization, currency: owner.currency,
          isCurrent: function () { return ownerIsCurrent(owner); },
          verifyAdded: function (payload) {
            var items = payload && Array.isArray(payload.items) ? payload.items : [payload];
            return items.length === 1 && exactOwnerLine(items[0], owner) ? items[0] : null;
          }
        });
      }).then(function (line) {
        if (!ownerIsCurrent(owner)) throw checkoutError("stale_cart_response");
        trackOnce("psychic_checkout_started", { package_tier: owner.tier, variant_id: owner.variantId });
        return openPreparedCheckout(owner, button, line);
      }).catch(function (error) {
        if (errorCode(error) !== "reading_cart_conflict") console.error("psychic_checkout_failed", error);
        return settleOwnerFailure(owner, error, button);
      });
    }
    function beginCheckout(tier, button, authorization) {
      if (state.checkoutOwner) return state.checkoutOwner.promise;
      var errorNode = one("[data-pc-checkout-error]");
      errorNode.textContent = "";
      var host = one("[data-pc-cart-recovery]");
      if (host) host.hidden = true;
      if (typedCrisis()) {
        errorNode.textContent = supportCopy("urgent");
        announce(errorNode.textContent);
        return Promise.resolve({ ok: false, support: true });
      }
      if (tier !== "indepth" || !state.sessionId || !state.sessionToken || state.restricted) {
        errorNode.textContent = state.restricted ? supportCopy("blocked") : copy.errProduct;
        announce(errorNode.textContent);
        return Promise.resolve({ ok: false });
      }
      trackOnce("psychic_package_selected", { package_tier: tier });
      var owner = {
        serial: ++state.checkoutSerial, sessionId: state.sessionId, sessionToken: state.sessionToken,
        tier: tier, variantId: PSYCHIC_PRODUCT_REGISTRY.indepth, expectedSku: PSYCHIC_PRODUCT_SKU,
        expectedProperties: {}, priceCents: 0, currency: "", selectionId: selectionId(),
        authorization: authorization || null, stale: false, promise: null,
      };
      state.checkoutOwner = owner;
      setBusy(button, true, copy.verifyPackage);
      updateOffer();
      owner.promise = Promise.resolve().then(function () { return runCheckoutOwner(owner, button); });
      return owner.promise;
    }

    function restore() {
      var saved;
      try { saved = JSON.parse(localStorage.getItem(storageKey) || "null"); } catch (_) { saved = null; }
      var savedCreatedAt = Number(saved && saved.createdAt || 0);
      if (!saved || !saved.sessionId || !saved.sessionToken || !Number.isFinite(savedCreatedAt) || savedCreatedAt <= 0 || Date.now() - savedCreatedAt > 30 * 86400000) {
        clearState();
        return false;
      }
      state.sessionId = saved.sessionId;
      state.sessionToken = saved.sessionToken;
      state.createdAt = savedCreatedAt;
      state.topic = saved.topic || "general";
      state.context = saved.context || "";
      state.birthDate = saved.birthDate || "";
      state.selectedSlots = Array.isArray(saved.selectedSlots) ? saved.selectedSlots.slice(0, 2) : [];
      state.offer = saved.offer || null;
      state.packages = [];
      state.marketStatus = "idle";
      state.marketPromise = null;
      state.result = saved.result && typeof saved.result === "object" ? saved.result : null;
      state.preview = saved.preview && typeof saved.preview === "object" ? saved.preview : null;
      state.previewVersion = String(saved.previewVersion || "");
      state.symbols = saved.symbols && typeof saved.symbols === "object" ? saved.symbols : null;
      state.followupAvailable = saved.followupAvailable === true;
      state.followup = saved.followup && typeof saved.followup === "object" ? saved.followup : null;
      state.restricted = Boolean(saved.restricted);
      updateOffer();
      if (state.selectedSlots.length !== 2) return false;
      trackOnce("psychic_return_visit");
      if (state.result && state.symbols) {
        renderResult({ reading: state.result, preview: state.preview, previewVersion: state.previewVersion, symbols: state.symbols, restricted: state.restricted, followupAvailable: state.followupAvailable, followup: state.followup });
        if (!state.restricted) hydrateMarketPackage(copy.packageFallback).catch(function () {});
        showStage("result", state.restricted ? "[data-pc-support]" : ".pc__reading");
        announce(copy.restored);
        return true;
      }
      renderCardSelection();
      showStage("cards", "[data-pc-generate]");
      announce(copy.restored);
      return true;
    }

    applyStaticCopy();
    updateOffer();

    one("[data-pc-question]").addEventListener("input", function () {
      if (!state.tracked.psychic_question_started && this.value.trim().length > 0) trackOnce("psychic_question_started");
      if (this.value.trim().length >= 8) one("[data-pc-question-error]").textContent = "";
      if (state.limitReached) renderLimitWall();
    });
    one("[data-pc-limit-cta]").addEventListener("click", saveLimitHandoff);
    Array.prototype.forEach.call(all("[data-topic]"), function (button) {
      button.setAttribute("aria-pressed", "false");
      button.addEventListener("click", function () {
        var active = button.classList.contains("is-active");
        Array.prototype.forEach.call(all("[data-topic]"), function (item) { item.classList.remove("is-active"); item.setAttribute("aria-pressed", "false"); });
        state.topicHint = active ? "" : button.getAttribute("data-topic");
        if (!active) { button.classList.add("is-active"); button.setAttribute("aria-pressed", "true"); }
      });
    });
    one("[data-pc-start]").addEventListener("click", startReading);
    one("[data-pc-context-continue]").addEventListener("click", continueToCards);
    one("[data-pc-back-question]").addEventListener("click", function () { showStage("question", "[data-pc-question]"); });
    one("[data-pc-back-context]").addEventListener("click", function () { showStage("context"); });
    Array.prototype.forEach.call(all("[data-card-slot]"), function (button) { button.addEventListener("click", function () { selectCard(button); }); });
    one("[data-pc-generate]").addEventListener("click", generateReading);
    one("[data-pc-followup-send]").addEventListener("click", sendFollowup);
    one("[data-pc-checkout]").addEventListener("click", function () { beginCheckout("indepth", this); });
    one("[data-pc-delete]").addEventListener("click", function () {
      if (state.checkoutOwner || state.checkoutInFlight) { announce(copy.verifyPackage); return; }
      if (!window.confirm(copy.deleteConfirm)) return;
      var button = this;
      setBusy(button, true, copy.deleting);
      api("/api/reading/delete", {
        method: "DELETE",
        headers: { "X-Session-Token": state.sessionToken },
        body: JSON.stringify({ sessionId: state.sessionId }),
      }).then(function () {
        clearState();
        window.location.reload();
      }).catch(function (error) {
        if (recoverUnavailableSession(error)) return;
        button.textContent = friendlyError(error);
        button.disabled = false;
      });
    });

    window.addEventListener("pageshow", function (event) {
      if (event.persisted && (state.checkoutOwner || state.checkoutInFlight)) {
        releaseCheckout(null, one("[data-pc-checkout]"));
        showCartRecovery(one("[data-pc-checkout]"));
      }
    });
    trackOnce("psychic_page_view");
    restore();
  });
})();
